import { Link } from 'react-router-dom';

const cases = [
  {
    title: 'Regulated financial services',
    text:
      'A tier-1 bank needed consistent evidence for model updates and customer-facing assistants. RakFort combined structured assessment with governance reporting so security, risk, and compliance could share one narrative.',
  },
  {
    title: 'Healthcare copilot rollout',
    text:
      'A health technology group deployed internal copilots across clinical support teams. RakFort helped define policy checks, monitor prompt patterns, and document residual risk for clinical safety review.',
  },
  {
    title: 'Software vendor with enterprise customers',
    text:
      'A B2B SaaS vendor added generative features to an existing product. RakFort aligned red teaming with their SDLC and gave customer-facing security summaries for procurement questionnaires.',
  },
];

export default function UseCases() {
  return (
    <>
      <div className="rf-hero-band border-b border-[#c5d4e3]/60">
        <div className="max-w-[1140px] mx-auto px-5 py-10 md:py-14">
          <p className="text-xs font-medium uppercase tracking-[0.12em] text-[#5c6d7e] mb-2">Use cases</p>
          <h1 className="text-2xl md:text-[1.85rem] font-semibold text-[#2c2c2c] tracking-tight max-w-3xl">
            How organisations use RakFort
          </h1>
          <p className="mt-4 text-[#5c5c5c] max-w-2xl leading-relaxed">
            Illustrative scenarios based on typical enterprise needs—adapted from the way integrators describe outcomes,
            not splashy marketing stories.
          </p>
        </div>
      </div>

      <section className="bg-[#f0f7ff] border-b border-[#e5eef6]">
        <div className="max-w-[1140px] mx-auto px-5 py-12 md:py-16 space-y-6">
          {cases.map((c) => (
            <article key={c.title} className="rf-card p-6 md:p-8 bg-white">
              <h2 className="text-lg font-semibold text-[#2c2c2c] mb-3">{c.title}</h2>
              <p className="text-[0.9375rem] text-[#5c5c5c] leading-relaxed max-w-3xl">{c.text}</p>
            </article>
          ))}

          <p className="text-[0.9375rem] text-[#5c5c5c] pt-4">
            Discuss your context:{' '}
            <Link to="/contactus" className="text-[#005a9c] font-medium hover:text-[#004a82]">
              Contact
            </Link>
          </p>
        </div>
      </section>
    </>
  );
}
